var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', [_vm._v("포인트 내역")]), _c('section', {
    staticClass: "mt-4"
  }, [_c('example-layout', {
    staticClass: "overflow-auto mt-8",
    scopedSlots: _vm._u([{
      key: "render",
      fn: function () {
        return [_c('example-point-history')];
      },
      proxy: true
    }, {
      key: "editor",
      fn: function () {
        return [_c('prism-editor', {
          staticClass: "rounded",
          attrs: {
            "line-numbers": ""
          },
          model: {
            value: _vm.section1.exampleCode,
            callback: function ($$v) {
              _vm.$set(_vm.section1, "exampleCode", $$v);
            },
            expression: "section1.exampleCode"
          }
        })];
      },
      proxy: true
    }])
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }